export default {
  CompanyIdFormField__ARIA: "SWABIZ Company ID",
  CompanyIdFormField__LABEL: "SWABIZ Company ID",
};
